import React, { ReactElement, ReactNode, useEffect } from 'react';

import { useAuth } from '@opendoor/auth-fe';
import { Box } from '@opendoor/bricks-next';
import { useRouter } from 'next/router';

interface BuyDirectCheckoutLayoutProps {
  children: ReactNode;
}

/**
 * Layout component for the Buy Direct Checkout flow.
 * Provides authentication protection and a minimal header.
 */
export const BuyDirectCheckoutLayout: React.FC<BuyDirectCheckoutLayoutProps> = ({ children }) => {
  const { authentication } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (authentication.state === 'not_authenticated') {
      window.location.assign(`/login?redirectTo=${encodeURIComponent(router.asPath)}`);
    }
  }, [authentication.state, router.asPath]);

  if (authentication.state === 'not_authenticated') {
    return null;
  }

  return (
    <Box flexDirection="column" backgroundColor="$backgroundPrimary" minHeight="100vh">
      {children}
    </Box>
  );
};

export const getBuyDirectCheckoutLayout = (page: ReactElement) => {
  return <BuyDirectCheckoutLayout>{page}</BuyDirectCheckoutLayout>;
};
